import React from "react";

function TermsAndConditions() {
  return (
    <div className="page__width mt-20">
      <h1 className="text-4xl mb-4 text-main-green">Общи условия</h1>
      <p className="text-sm mb-2 text-body">
        Настоящите общи условия ce oтнacят дo използването на yeб caйт
        premiumservices.bg, собственост на „Премиум сървисес“ ООД, както и за
        използването на услуги, предлагани от “„Премиум сървисес“ ООД ПРЕДМЕТ
      </p>
      <p className="text-sm mb-2 text-body">
        Чл. 1. Настоящите общи условия са предназначени за регулиране на
        отношенията между „Премиум сървисес“ ООД, наричано по-долу за краткост
        ДОСТАВЧИК (наричан още ИЗПЪЛНИТЕЛ), и потребителите, наричани по-долу
        ПОЛЗВАТЕЛИ (наричани още ВЪЗЛОЖИТЕЛИ), на предоставяната от него услуги
        на информационното общество, наричани по-долу УСЛУГАТА
      </p>
      <h2 className="text-2xl mb-4 text-main-green">ІІ. ДАННИ ЗА ДОСТАВЧИКА</h2>
      <p className="text-sm mb-2 text-body">
      Чл. 2. Информация съгласно Закона за електронната търговия и Закона за
        защита на потребителите
        <li className="text-sm text-body mb-2 list-none">
        Дружество: „Премиум сървисес“ ООД
        </li>
        <li className="text-sm text-body mb-2 list-none">
          ЕИК/БУЛСТАТ: 207511526
        </li>
        <li className="text-sm text-body mb-2 list-none">
          Седалище и адрес на управление: гр. Пловдив, ул.“Средец” № 77, ет. 4,
          ап. 13
        </li>
        <h2 className="text-lg uppercase my-4 text-main-green">Надзорни органи</h2>
        <li className="text-sm text-body mb-2 list-none">
        Дружество: Комисия за Защита на
        Лични Данни Седалище и адрес на управление
        </li>
        <li className="text-sm text-body mb-2 list-none">
          Седалище и адрес на управление: гр. София 1592, бул. „Проф. Цветан
          Лазаров” 2
        </li>
        <li className="text-sm text-body mb-2 list-none">
            Email: kzld@government.bg, kzld@cpdp.bg
        </li>
        <li className="text-sm text-body mb-2 list-none">
          Адрес за кореспонденция: гр. София 1592, бул. „Проф. Цветан Лазаров” 2
        </li>
        <li className="text-sm text-body mb-2 list-none">
          Телефон: 02/ 915 3 518
        </li>
        <li className="text-sm text-body mb-2 list-none">
          Уеб сайт: www.cpdp.bg
        </li>
      </p>
      <h2 className="text-2xl mb-4 text-main-green">
        III. ХАРАКТЕРИСТИКИ НА УСЛУГАТА
      </h2>
      <p className="text-sm mb-2 text-body">
        Чл. 3.ИЗПЪЛНИТЕЛЯТ посредством технически съоръжения предоставя
        възможността на всеки потребител, да използва услугите на сайта 24 часа
        в денонощието – 7 дни в седмицата. Допускат се кратки моменти, през
        които тече профилактика или обновяване на информация в сайта, през които
        той може да е недостъпен за ползване. Възможни са също сривове в
        доставката на интернет, поради прекъсване на телекомуникационните
        връзки, за което ИЗПЪЛНИТЕЛЯТ не носи отговорност. Вие се съгласявате,
        че ИЗПЪЛНИТЕЛЯТ, не носи отговорност при модифициране или временно
        прекъсване на услугата. Чл. 4. Доставчикът предоставя, а Ползвателите
        използват Услугата, съгласно параметрите, обявени на страницата на
        Доставчика в Интернет и спрямо предоставеният документ „Оферта“,
        предоставен на Ползвателя по официални канали за кореспонденция.
      </p>
      <h2 className="text-2xl mb-4 text-main-green">IV. ЦЕНА НА УСЛУГАТА</h2>
      <p className="text-sm mb-2 text-body">
        Чл. 5. (1) Доставчикът предоставя Услугата срещу възнаграждение, дължимо
        от Ползвателя след подписване на договор между двете страни на хартиен
        носител и одобрен чрез поставяне на подпис от двете страни,когато
        Услугата се предоставя възмездно. (2) Информация за различните параметри
        на Услугата е достъпна на страницата на Доставчика в Интернет, както и в
        предоставеният документ „Оферта“, предоставен на Ползвателя по официални
        канали за кореспонденция.. Чл. 6. (1) Ползвателят заплаща цената на
        Услугата съобразно определеното от Доставчика в предоставения документ
        „Оферта“, предоставен на Ползвателя в офис на Доставчика след
        предварително запазен час и постигнане на съгласие между двете страни,
        когато Услугата се предоставя възмездно.
      </p>
      <h2 className="text-2xl mb-4 text-main-green">
        V. ПРЕДОСТАВЯНЕ НА УСЛУГАТА И СТЪПКИ ЗА СКЛЮЧВАНЕ НА ДОГОВОРА
      </h2>
      <p className="text-sm mb-2 text-body">
        Чл. 7 (1) Настоящите общи условия се прилагат както към услуги, за които
        се изисква регистрация, така и за такива, за които не се изисква
        регистрация; (2) Доставчика на Услугата предоставя на Ползвателя
        официален документ „Оферта“; (3) След потвърждаването на условията в
        документ „Оферта“ чрез поставяне на подпис, се предоставя на Ползвателя
        официален документ „Договор“, създаден спрямо условията в документ
        „Оферта. След потвърждаване на условията и в документ „Договор“, между
        Ползвателя и Доставчика възникват договорни отношения; (4) Ползвателят
        се задължава да предостави верни и актуални данни, които да бъдат
        използвани за официални документи „Оферта“ и „Договор“. Ползвателят се
        задължава да уведоми своевременно Доставчика при промяна на данните, за
        да бъдат те актуализирани; (5) Доставчикът има право на достъп до
        данните, необходими за идентифициране на Ползвателя, в случаи, в които
        това е необходимо и които са надлежно описани в Политика за
        поверителност, достъпна на уеб адрес https://premiumservices.bg/gdpr/;
        Чл. 8. (1) Ползвателите използват официалните канали за кореспонденция с
        Доставчика, за извършване на изявления в отношенията помежду им. (2)
        Договорът се сключва на български език. (3) Договорът между Доставчика и
        Ползвателя представлява настоящите Oбщи условия, достъпни на уеб адрес
        https://premiumservices.bg/obshti-uslovia/, заедно с всички изменения и
        допълнения в тях, както и официални документи „Оферта“ и „Договор“; (4)
        Страна по договора с Доставчика е Ползвателят на Услугата съгласно
        данните, предоставени при желание от страна на Ползвателя да се
        възползва от предлаганата от Доставчика Услуга.; (5) Договорните
        отношения се считат за официално сключени от момента на подписване на
        официални документи „Оферта“ и „Договор“ на хартиен носител в офис на
        Доставчика, както и на настоящите Общи условия; Чл. 9. (1) Ползвателят
        има право да използва Услугата добросъвестно и по предназначение.; (2)
        Ползвателят се задължава да не използва Услугата в противоречие с
        приложимото законодателство; Чл. 10. Ползвателят се задължава да
        осигурява за достъп до всякакъв тип средства, необходими за адекватното
        предоставяне на Услугата и нейното управление, необходими коректното
        изпълнение на договорните отношения за извършване на Услугата; Чл. 11.
        (1) С оглед повишаване качеството на Услугата, извършване на
        профилактика, отстраняване на повреди и други свързани с това дейности,
        Доставчикът има право временно да ограничи или преустанови
        предоставянето на Услугата; (2) В случаите по ал. 1, Доставчикът е
        задължен своевременно да възстанови предоставянето на услугата след
        отпадане на обстоятелството, което е причина за преустановяването; Чл.
        12. (1) Доставчикът предприема мерки за защита на личните данни на
        Ползвателя съгласно Закона за защита на личните данни. (2) От
        съображения за сигурност на личните данни на Ползвателите, Доставчикът
        ще изпрати данните само на e-mail адрес, който е бил посочен от
        Ползвателите; (3) Доставчикът приема и обявява на сайта си Политика за
        поверителност, достъпна на уеб адрес https://premiumservices.bg/gdpr.
        Ползвателят се съгласява с Политиката за поверителност на Доставчика.
        (4) Ползвателят се съгласява, че Доставчикът има право да обработва
        личните му данни съгласно Политиката за поверителност; Чл. 13. Във всеки
        момент преди, по време или след предоставяне на Услугата, Доставчикът
        има право да изисква от Ползвателя да се легитимира и да удостовери
        достоверността на всички обявени по време на договорните отношения
        обстоятелства и лични данни; Чл. 14. Доставчикът НЕ носи отговорност за
        променена, непълна и/или грешна, и/или зловредна функционалност на
        използвани приложения, допълнения и/или дигитални активи, предоставени
        от трети лица.
      </p>
      <h2 className="text-2xl mb-4 text-main-green">
        VI. ИЗМЕНЕНИЕ И ДОСТЪП ДО ОБЩИТЕ УСЛОВИЯ
      </h2>
      <p className="text-sm mb-2 text-body">
        Чл. 15. (1) Настоящите Общи условия могат да бъдат изменяни от
        Доставчика; (2) Доставчикът и Ползвателят се съгласяват, че всяко
        допълване и изменение на тези Общи условия ще има действие спрямо
        Ползвателя след изричното му уведомяване от Доставчика и ако Ползвателят
        не заяви в предоставения му 14-дневен срок, че ги отхвърля; (3)
        Ползвателят се съгласява, че всички изявления на Доставчика, във връзка
        с изменението на тези Общи условия ще бъдат изпратени на адреса на
        електронната поща, посочена от Ползвателя, при изявяване на желание за
        използване на Услугата. Ползвателят на Услугата се съгласява, че
        електронните писма, изпратени по реда на този член не е необходимо да
        бъдат подписани с електронен подпис, за да имат действие спрямо него;
      </p>
      <h2 className="text-2xl mb-4 text-main-green">VII. ПРЕКРАТЯВАНЕ</h2>
      <p className="text-sm mb-2 text-body">
        Чл. 16. Договорът за предоставяне на Услугата се прекратява: с изтичане
        на срока на сключения между Ползвателя и Доставчика договор за
        предоставяне на Услугата; при прекратяване и обявяване в ликвидация или
        обявяване в несъстоятелност на една от страните по договора; по взаимно
        съгласие на страните в писмен вид; едностранно с предизвестие от всяка
        от страните в случай на неизпълнение на задълженията на другата страна;
        при обективна невъзможност на някоя от страните по договора да изпълнява
        задълженията си; при изземване или запечатване на оборудване от държавни
        органи;. в случаите по чл. 9, ал. 2 от тези Общи условия; Чл. 17.
        Доставчикът има право по свое усмотрение, без да отправя предизвестие да
        прекрати едностранно договора, в случай че установи, че предоставяните
        Услуги и доброто име на Доставчика се използват в нарушение на
        настоящите Общи условия, законодателството в Република България и
        общоприетите нравствени норми;
      </p>
      <h2 className="text-2xl mb-4 text-main-green">VIII. ДРУГИ УСЛОВИЯ</h2>
      <p className="text-sm mb-2 text-body">
        Чл. 18. Евентуалната недействителност на някоя от разпоредбите на тези
        Общи условия няма да води до недействителност на целия договор; Чл. 19.
        За неуредените в този договор въпроси, свързани с изпълнението и
        тълкуването на Договора, се прилагат законите на Република България; Чл.
        20. Всички спорове между страните по Договора ще бъдат разрешавани от
        компетентния съд или Комисията за защита на потребителите. Чл. 21.
        Настоящите Общи условия влизат в сила за Ползвателя веднага след тяхното
        одобрение чрез поставяне на подпис;
      </p>
    </div>
  );
}

export default TermsAndConditions;
